import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import { Main } from './components/Main/Main';
import { PressKit } from './components/PressKit/PressKit';


import './App.css';


function App() {

 

  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }



  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  });


  return (
    <div className="App">
       <Router>

        <Routes>
          <Route exact path='/' element={<Main width={width} />} />
          <Route path='/k/mw-ts-k4n8' element={<PressKit />} />

        </Routes>

      </Router>
     
    </div>
  );
}

export default App;